import { gql } from "@apollo/client";

export const INSERT_FEED_BACK = gql`
mutation feedbackInsert($data:   FeedbackInsertInput!) {
    result: feedbackInsert(args: $data) {
      id
    }
  }
`